
import { Box, Typography } from '@mui/material';
import React, { FC } from 'react';
import { Colors } from '../../constants';
import { ArrowDownIcon, SettingsIcon } from '../../icons';

type CollapseTriggerWithIconProps = {
	isActivated: boolean;
	setIsActivated(value: boolean): void;
};

export const CollapseTriggerWithIcon: FC<CollapseTriggerWithIconProps> = ({ isActivated, setIsActivated }) => (
	<Box
		sx={{
			display: 'flex',
			alignItems: 'center',
			gap: '8px',
			cursor: 'pointer',
		}}
		onClick={() => {
			setIsActivated(!isActivated);
		}}
	>
		<SettingsIcon />
		<Typography
			sx={{
				fontSize: '14px',
				fontWeight: 500,
				lineHeight: '22px',
				color: Colors.white_a80
			}}
		>
			Advanced Settings
		</Typography>
		<ArrowDownIcon
			style={{
				width: '16px',
				height: '16px',
				transform: isActivated ? 'rotate(180deg)' : undefined
			}}
		/>
	</Box>
);
